export default __webpack_public_path__ + "static/media/Paystack-CeruleanBlue-StackBlue-HL.f9fa1764.png";